export default __webpack_public_path__ + "static/media/REL-DIN.2f4a2c13.png";